<template>
  <div class="toggle-menu">
    <TooltipStandardV2
      v-if="enabledButtons.includes('timeseries')"
      :text="t('general__text__all_types_of_data_visualization')"
      :arrowPosition="'top-center'"
      :verticalOffset="2"
    >
      <span class="badge" :class="{ active: selected.includes('all') }" @click="toggle('all')">
        {{ t('general__text__all') }}
      </span>
    </TooltipStandardV2>

    <TooltipStandardV2
      v-if="enabledButtons.includes('timeseries')"
      :text="t('dashboard__text__measurement_values')"
      :arrowPosition="'top-center'"
      :verticalOffset="2"
    >
      <IconSpeedMeter
        class="badge"
        :class="{ active: selected.includes('measurement') }"
        @click="toggle('measurement')"
      />
    </TooltipStandardV2>

    <TooltipStandardV2
      v-if="enabledButtons.includes('timeseries')"
      :text="t('dashboard__text__chart-graphs')"
      :arrowPosition="'top-center'"
      :verticalOffset="2"
    >
      <IconLineChart
        class="badge"
        :class="{ active: selected.includes('graphs') }"
        @click="toggle('graphs')"
      />
    </TooltipStandardV2>

    <TooltipStandardV2
      v-if="enabledButtons.includes('heatmap')"
      :text="t('dashboard__text__chart-heatmaps')"
      :arrowPosition="'top-center'"
      :verticalOffset="2"
    >
      <IconLayoutGrid
        class="badge"
        :class="{ active: selected.includes('heatmap') }"
        @click="toggle('heatmap')"
      />
    </TooltipStandardV2>

    <TooltipStandardV2
      v-if="link && link.name"
      :text="link.name"
      :arrowPosition="'top-center'"
      :verticalOffset="2"
    >
      <a class="a-href" :href="link.address" target="_blank" rel="noreferrer noopener">
        <IconExternalLInk class="badge" />
      </a>
    </TooltipStandardV2>
  </div>
</template>

<script setup lang="ts">
import IconSpeedMeter from '../assets/icons/IconSpeedMeter.vue'
import IconLineChart from '../assets/icons/IconLineChart.vue'
import IconLayoutGrid from '../assets/icons/IconLayoutGrid.vue'
import IconExternalLInk from '../assets/icons/IconExternalLink.vue'
import TooltipStandardV2 from '../atoms/TooltipStandardV2.vue'

import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
  enabledButtons: string[]
  selected: string[]
  link?: {
    address: string
    name: string
  }
}>()

type Emits = (e: 'toggle', toggleData: string) => void
const emits = defineEmits<Emits>()

function toggle(toggleData: string) {
  emits('toggle', toggleData)
}
</script>

<style scoped lang="scss">
@use '@/design-system/design-tokens/font-mixins';
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-variables.scss';
.toggle-menu {
  display: flex;
  gap: 4px;
}
.badge {
  background-color: #e0e0e0;
  padding: 3px 6px;
  border-radius: 24px;
  cursor: pointer;
  color: #1a1a1a;
  height: 24px;
  min-width: 34px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s, color 0.3s;
  @include font-mixins.desktop-regular-label;
}
.badge.active {
  background-color: #767676;
  color: #ffffff;
}
.a-href {
  padding: 0;
  margin: 0;
  text-decoration: none;
  color: #1a1a1a;
  display: flex; /* Ensures alignment matches others */
  align-items: center; /* Centers the icon vertically */
}
</style>
